import React from 'react';
import parse from 'html-react-parser';
import { IDisclosure } from '../../interfaces/generic';
type DisclosureWithSymbolProps = {
  className?: string;
  symbol?: string;
  disclosure: IDisclosure;
  notSuperscriptSymbol?: boolean;
};
class DisclosureWithSymbol extends React.Component<DisclosureWithSymbolProps> {
  constructor(props: DisclosureWithSymbolProps) {
    super(props);
  }
  render() {
    const cl = this.props.className ? `${this.props.className} ` : '';
    const symbol = this.props.symbol || this.props.disclosure.symbol;
    const copy = this.props.disclosure.copy;
    const returnSymbol = (symbol: any) => {
      return this.props.notSuperscriptSymbol ? symbol : `<sup>${symbol}</sup>`;
    };
    return <p className={`${cl}body-text-sm`}>{parse(`${returnSymbol(symbol)}${copy}`)}</p>;
  }
}

export default DisclosureWithSymbol;
